import { LoginEventPopupFlow } from '@constants/common';
import { PopupType } from '@constants/popupType';

// The host page opens the login popup itself: its delegated handlers read these
// attributes off the clicked button. Calling `PopupMaker.show('popup_login')`
// directly would skip the no-redirect setup and bounce the user off the page
// after login. Same approach as `useFunnelAiTools`.
const ATTRIBUTE_TARGET = 'data-popup-target';
const ATTRIBUTE_NO_REDIRECT = 'data-popup-login-no-redirect';
const ATTRIBUTE_DATA = 'data-popup-data';

/**
 * Attributes that turn a button into the host login trigger: a click opens the
 * login popup and keeps the user on the page afterwards.
 */
export const getLoginPopupAttributes = (
  flow: LoginEventPopupFlow
): Record<string, string> => ({
  [ATTRIBUTE_TARGET]: PopupType.LOGIN,
  [ATTRIBUTE_NO_REDIRECT]: '1',
  [ATTRIBUTE_DATA]: JSON.stringify({ flow }),
});

/**
 * Opens the host login popup without a click from the user: a throwaway trigger
 * with `getLoginPopupAttributes` goes through the same delegated handler a
 * button would. The one place React asks the host for a login from code.
 */
export const openHostLoginPopup = (flow: LoginEventPopupFlow) => {
  const trigger = document.createElement('button');

  trigger.type = 'button';
  trigger.hidden = true;
  Object.entries(getLoginPopupAttributes(flow)).forEach(([name, value]) =>
    trigger.setAttribute(name, value)
  );

  document.body.appendChild(trigger);
  trigger.click();
  trigger.remove();
};
